// src/pages/produccion/PorcentajeMerma.jsx
import { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import api from '../../services/api';

const META = 0.3; // % — según la ficha del KPI

const MESES = [
  ['01', 'Enero'], ['02', 'Febrero'], ['03', 'Marzo'], ['04', 'Abril'], ['05', 'Mayo'], ['06', 'Junio'],
  ['07', 'Julio'], ['08', 'Agosto'], ['09', 'Septiembre'], ['10', 'Octubre'], ['11', 'Noviembre'], ['12', 'Diciembre'],
];
function ultimoDiaDelMes(anio, mes) {
  return new Date(anio, parseInt(mes), 0).getDate();
}
function primerDiaMesActual() {
  const hoy = new Date();
  return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-01`;
}

export default function PorcentajeMerma() {
  const [registros, setRegistros] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  const [fDesde, setFDesde] = useState(primerDiaMesActual());
  const [fHasta, setFHasta] = useState(new Date().toISOString().slice(0, 10));
  const [fMes, setFMes] = useState('');
  const [fAnio, setFAnio] = useState(new Date().getFullYear());
  const [fLinea, setFLinea] = useState('');

  async function cargar() {
    try {
      setCargando(true);
      const params = {};
      if (fDesde) params.desde = fDesde;
      if (fHasta) params.hasta = fHasta;
      if (fLinea) params.linea = fLinea;
      const res = await api.get('/api/produccion/merma-scrap-resumen', { params });
      setRegistros(res.data.data);
      setError(null);
    } catch (err) {
      console.error(err);
      setError('No se pudo cargar el resumen.');
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleMesChange(mes) {
    setFMes(mes);
    if (mes) {
      setFDesde(`${fAnio}-${mes}-01`);
      setFHasta(`${fAnio}-${mes}-${String(ultimoDiaDelMes(fAnio, mes)).padStart(2, '0')}`);
    }
  }

  function exportarExcel() {
    const filas = registros.map((r) => ({
      Línea: r.linea,
      'Total Merma (kg)': r.total_merma.toFixed(2),
      'Total Mezclado (kg)': r.total_mezclado.toFixed(2),
      '% Merma': r.pct_merma.toFixed(3),
    }));
    const ws = XLSX.utils.json_to_sheet(filas);
    ws['!cols'] = [{ wch: 10 }, { wch: 16 }, { wch: 18 }, { wch: 12 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, '% Merma');
    XLSX.writeFile(wb, `dasavena_pct_merma_${new Date().toISOString().slice(0, 10)}.xlsx`);
  }

  const totalMerma = registros.reduce((s, r) => s + r.total_merma, 0);
  const totalMezclado = registros.reduce((s, r) => s + r.total_mezclado, 0);
  const pctGlobal = totalMezclado > 0 ? (totalMerma / totalMezclado) * 100 : 0;
  const semaforo = pctGlobal <= META ? '#3E7C5A' : pctGlobal <= META * 3 ? '#C08A2B' : '#B23A48';

  return (
    <div style={styles.paginaContenedor}>
      <div style={styles.headerFila}>
        <div>
          <h1 style={styles.tituloPagina}>% Merma (Scrap)</h1>
          <p style={styles.subtituloPagina}>% Merma = Total Merma ÷ Total Kg Mezclado · Meta: &lt;{META}%</p>
        </div>
        <button onClick={exportarExcel} disabled={registros.length === 0} style={styles.botonExcel}>⬇ Descargar Excel</button>
      </div>

      <div style={styles.kgrid}>
        <div style={{ ...styles.kcard, borderTop: `3px solid ${semaforo}` }}>
          <div style={styles.kLbl}>% Merma Global</div>
          <div style={{ ...styles.kVal, color: semaforo }}>{pctGlobal.toFixed(2)}%</div>
          <div style={styles.kSub}>meta: &lt;{META}%</div>
        </div>
        <div style={styles.kcard}>
          <div style={styles.kLbl}>Total Merma</div>
          <div style={styles.kVal}>{totalMerma.toFixed(0)} kg</div>
        </div>
        <div style={styles.kcard}>
          <div style={styles.kLbl}>Total Mezclado</div>
          <div style={styles.kVal}>{totalMezclado.toFixed(0)} kg</div>
        </div>
      </div>

      <div style={styles.filtrosBar}>
        <FiltroFecha label="Desde" value={fDesde} onChange={(v) => { setFDesde(v); setFMes(''); }} />
        <FiltroFecha label="Hasta" value={fHasta} onChange={(v) => { setFHasta(v); setFMes(''); }} />
        <FiltroSel label="Mes" value={fMes} onChange={handleMesChange} options={[['', '—'], ...MESES]} />
        <div style={styles.filtroGrupo}>
          <label style={styles.filtroLabel}>Año</label>
          <input type="number" value={fAnio} onChange={(e) => setFAnio(e.target.value)} style={{ ...styles.filtroInput, width: '80px' }} />
        </div>
        <FiltroSel label="Línea" value={fLinea} onChange={setFLinea} options={[['', 'Todas'], ['Granola', 'Granola'], ['Barras', 'Barras']]} />
        <button onClick={cargar} style={styles.botonBuscar2}>Buscar</button>
      </div>

      {cargando ? <div>Cargando...</div> : error ? <div style={{ color: '#B23A48' }}>{error}</div> : (
        <div style={styles.tablaScroll}>
          <table style={styles.tabla}>
            <thead>
              <tr>
                <th style={styles.th}>Línea</th><th style={styles.th}>Total Merma (kg)</th>
                <th style={styles.th}>Total Mezclado (kg)</th><th style={styles.th}>% Merma</th>
              </tr>
            </thead>
            <tbody>
              {registros.map((r) => {
                const color = r.pct_merma <= META ? '#3E7C5A' : r.pct_merma <= META * 3 ? '#C08A2B' : '#B23A48';
                return (
                  <tr key={r.linea}>
                    <td style={styles.td}>{r.linea}</td>
                    <td style={styles.td}>{r.total_merma.toFixed(2)}</td>
                    <td style={styles.td}>{r.total_mezclado.toFixed(2)}</td>
                    <td style={{ ...styles.td, fontWeight: 700, color }}>{r.pct_merma.toFixed(3)}%</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {registros.length === 0 && <p style={{ padding: 16, color: '#8A7690', fontSize: 12 }}>Sin datos para este período.</p>}
        </div>
      )}
    </div>
  );
}

function FiltroSel({ label, value, onChange, options }) {
  return (
    <div style={styles.filtroGrupo}>
      <label style={styles.filtroLabel}>{label}</label>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={styles.filtroInput}>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
  );
}
function FiltroFecha({ label, value, onChange }) {
  return (
    <div style={styles.filtroGrupo}>
      <label style={styles.filtroLabel}>{label}</label>
      <input type="date" value={value} onChange={(e) => onChange(e.target.value)} style={styles.filtroInput} />
    </div>
  );
}

const styles = {
  paginaContenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42' },
  headerFila: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '14px', marginBottom: '4px' },
  tituloPagina: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '2px' },
  subtituloPagina: { fontSize: '12px', color: '#8A7690' },
  botonExcel: { padding: '8px 16px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#3E7C5A', border: 'none', borderRadius: '8px', cursor: 'pointer', flexShrink: 0 },
  kgrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '14px', marginTop: '14px', marginBottom: '14px' },
  kcard: { background: '#fff', border: '1px solid #E6DDD2', borderTop: '3px solid #4A1E5C', borderRadius: '12px', padding: '16px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  kLbl: { fontSize: '11px', fontWeight: 500, color: '#8A7690', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '8px' },
  kVal: { fontSize: '24px', fontWeight: 700, color: '#2A1830' },
  kSub: { fontSize: '11px', color: '#8A7690', marginTop: '4px' },
  filtrosBar: { display: 'flex', alignItems: 'flex-end', gap: '12px', flexWrap: 'wrap', background: '#fff', border: '1px solid #E6DDD2', borderRadius: '10px', padding: '14px 16px', marginBottom: '10px' },
  filtroGrupo: { display: 'flex', flexDirection: 'column', gap: '4px' },
  filtroLabel: { fontSize: '10px', color: '#8A7690', textTransform: 'uppercase', letterSpacing: '0.4px' },
  filtroInput: { padding: '6px 8px', fontSize: '12px', border: '1px solid #E6DDD2', borderRadius: '6px', fontFamily: 'Inter, sans-serif' },
  botonBuscar2: { padding: '7px 16px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#4A1E5C', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  tablaScroll: { overflowX: 'auto', background: '#fff', border: '1px solid #E6DDD2', borderRadius: '10px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '13px' },
  th: { textAlign: 'left', padding: '8px 10px', borderBottom: '2px solid #E6DDD2', color: '#6E4F80', fontWeight: 600, fontSize: '11px', textTransform: 'uppercase', whiteSpace: 'nowrap' },
  td: { padding: '6px 10px', borderBottom: '1px solid #F0E9E0', whiteSpace: 'nowrap' },
};